module.exports = __webpack_public_path__ + "static/media/7sport_Black.99f90bf8.png";